import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ChangePassword from '../../components/Forget/Change';
import { usePasswordChangeMutation } from '../../services/auth';
import * as routes from '../../pages/routes';
import MockUp from '../Register/mockUp';
import TokenManager from '../../utils/tokenManager';
import handleSubmitError from '../../utils/authErrors';

const ChangePasswordContainer = () => {
  const navigate = useNavigate();

  const [change, { isLoading, isSuccess }] = usePasswordChangeMutation();

  // The reset token only ever authorised this page; done or abandoned, it goes when the page does.
  useEffect(() => () => TokenManager.clearPending(), []);

  const handleOnSubmit = (values: {
    new_password1: string | number;
    new_password2: string | number;
  }) => {
    change({
      new_password1: values.new_password1.toString(),
      new_password2: values.new_password2.toString()
    })
      .unwrap()
      .then(() => {
        // Shown by the login page (containers/Login), which reads and clears it.
        sessionStorage.setItem(
          'flashMessage',
          'رمز عبور شما با موفقیت تغییر کرد.'
        );
        navigate(routes.LOGIN);
      })
      .catch(handleSubmitError);
  };

  return (
    <>
      <ChangePassword
        onSubmit={handleOnSubmit}
        isLoading={isLoading || isSuccess}
      />
      <MockUp />
    </>
  );
};

export default ChangePasswordContainer;
